/**
 * Definición de URL Servidores
 */
//const host = "https://iot-backend-ilesa.idtolu.net"; //production
//const host = "https://bck-ilesa.idtolu.net"; //Cluster Development
//const host = "http://179.1.87.45:3151/api/v1";
const host = "https://backend-olimpica.idtolu.net/api/v1"; //Remote Server Developmet

//const host = "http://localhost:3151/api/v1"; //Local Server

/**
 *
 * @returns path Server Local
 */
export function server() {
  const server = host;
  return server;
}
